module.exports = __webpack_public_path__ + "static/media/hashtag.ba93f89a.svg";